import { API_ENDPOINTS } from "@/api/services/attendanceManagement/apiEndPoint";
import { baseApi } from "@/utils/baseApi";

export const attendanceMusterListApi = baseApi.injectEndpoints({

  endpoints: (builder) => ({
    getAttendanceMuster: builder.query({
      query: ({ empId, reviewer, repManager, payrollStatus, yearMonth, sortDirection, page, size, search }) =>
        ({url: API_ENDPOINTS.ATTENDANCE_MUSTER.GET_ATTENDANCE_MUSTER(empId, reviewer, repManager, payrollStatus, yearMonth, sortDirection, page, size, search)}),
      providesTags: ["AttendanceMuster"],
    }),

    // add LOP
    addLOP: builder.mutation({
      query: ({ data }) => {
        return {
          url: API_ENDPOINTS.ATTENDANCE_MUSTER.ADD_LOP(),
          method: "POST",
          body: data,
        };
      },
      invalidatesTags: ["AttendanceMuster"],
    }),

    // process Attendance
    processAttendance: builder.mutation({
      query: ({ params }) => {
        return {
          url: API_ENDPOINTS.ATTENDANCE_MUSTER.PROCESS_ATTENDANCE(params),
          method: "POST",
          // body: data,
        };
      }
    }),

    // bulk override
    getOverride: builder.query({
      query: ({ empId, month }) =>
       ({url: API_ENDPOINTS.ATTENDANCE_MUSTER.GET_OVERRIDE(
          empId,
          month
        )}),
      providesTags: (result) =>
        result && Array.isArray(result)
          ? [{ type: "Override", id: "LIST" }]
          : [{ type: "Override", id: "LIST" }],
    }),

    // update override
    updateOverride: builder.mutation({
      query: ({ formData }) => ({
        url: API_ENDPOINTS.ATTENDANCE_MUSTER.UPDATE_OVERRIDE(),
        method: "PUT",
        body: formData,
      }),
      invalidatesTags: ["Override"],
    }),

    // override history
    getOverrideHistory: builder.query({
      query: ({ empId, month }) =>
        ({url: API_ENDPOINTS.ATTENDANCE_MUSTER.GET_OVERRIDE_HISTORY(
          empId,
          month
        )}),
      providesTags: (result) =>
        result && Array.isArray(result)
          ? [{ type: "OverrideHistory", id: "LIST" }]
          : [{ type: "OverrideHistory", id: "LIST" }],
    }),

    // delete override
    deleteOverride: builder.mutation({
      query: ({ formData }) => ({
        url: API_ENDPOINTS.ATTENDANCE_MUSTER.DELETE_OVERRIDE(),
        method: "DELETE",
        body: formData,
      }),
      invalidatesTags: ["OverrideHistory"],
    }),

    // sample excel
    getSampleExcel: builder.query({
      query: () => ({
        url: API_ENDPOINTS.ATTENDANCE_MUSTER.GET_SAMPLE_EXCEL(),
        responseHandler: async (response) => response.blob(), // Ensure Blob conversion
      }),
      providesTags: ["AttendanceMuster"],
    }),
    // /attendance-muster/import
    musterImport: builder.mutation({
      query: ({ formData }) => {
        return {
          url: API_ENDPOINTS.ATTENDANCE_MUSTER.MUSTER_IMPORT(),
          method: "POST",
          body: formData,
          responseHandler: async (response) => {
            if (!response.ok) {
              const errorData = await response.json();
              console.log(errorData);
              return errorData;
            }
            return response.blob();
          },
        };
      },
    }),

    // get lop
    getLOP: builder.query({
      query: ({ empId, month }) =>
        ({url: API_ENDPOINTS.ATTENDANCE_MUSTER.GET_LOP(empId, month)}),
      providesTags: (result, error, { empId, month }) => [
        { type: "AttendanceMuster", id: `LOP-${empId}-${month}` },
      ],
    }),

    // download muster excel
    getDownloadMusterExcel: builder.query({
      query: ({ yearMonth }) => ({
        url: API_ENDPOINTS.ATTENDANCE_MUSTER.GET_DOWNLOAD_MUSTER_EXCEL(yearMonth),
        responseHandler: async (response) => response.blob(), // Ensure Blob conversion
      }),
      providesTags: ["AttendanceMuster"],
    }),


  }),
});

export const { useGetAttendanceMusterQuery, useAddLOPMutation,
  useProcessAttendanceMutation, useGetOverrideQuery,
  useGetSampleExcelQuery, useUpdateOverrideMutation, useMusterImportMutation,
  useGetOverrideHistoryQuery, useDeleteOverrideMutation, useGetLOPQuery, useLazyGetDownloadMusterExcelQuery } = attendanceMusterListApi;
